import React from "react";
import { Logo } from "@/components/Logo";

export function AuthShell({ title, subtitle, children, footer, hideLogo = false }) {
  return (
    <div className="min-h-screen bg-background mm-grid-bg flex flex-col items-center justify-center px-4 py-10">
      <div className="w-full max-w-md mm-fade-in">
        {!hideLogo && <div className="flex justify-center mb-8"><Logo size="lg" /></div>}
        <div className="rounded-2xl border border-slate-800 bg-slate-900/70 backdrop-blur-xl p-7 sm:p-8 shadow-2xl">
          <h1 className="font-display text-2xl font-bold text-center">{title}</h1>
          {subtitle && <p className="mt-2 text-sm text-slate-400 text-center">{subtitle}</p>}
          <div className="mt-6">{children}</div>
        </div>
        {footer && <div className="mt-5 text-center text-sm text-slate-400">{footer}</div>}
      </div>
    </div>
  );
}
